import { INTRO_ENTER_S } from '../intro/introTiming';

export const MOTION_EASE = [0.22, 1, 0.36, 1] as const;

/** Langsamer Ausklang für Intro-Curtain → Hero */
export const INTRO_EXIT_EASE = [0.4, 0, 0.15, 1] as const;

export const BLUR_REVEAL_DURATION = 0.53;

export const blurReveal = (delay = 0) => ({
  initial: { opacity: 0, filter: 'blur(22px)' },
  animate: { opacity: 1, filter: 'blur(0px)' },
  transition: { duration: BLUR_REVEAL_DURATION, ease: MOTION_EASE, delay },
});

/** Opener-Einfaden — Logo + Tagline (gleiche Dauer) */
export const introOpenerEnter = {
  initial: { opacity: 0, filter: 'blur(22px)' },
  animate: { opacity: 1, filter: 'blur(0px)' },
  transition: { duration: INTRO_ENTER_S, ease: MOTION_EASE, delay: 0 },
};

/** Hero: Logo + Headlines gemeinsam, etwas langsamer */
export const HERO_ENTRANCE_DURATION = 0.78;

export const heroEntrance = (delay = 0) => ({
  initial: { opacity: 0, filter: 'blur(22px)' },
  animate: { opacity: 1, filter: 'blur(0px)' },
  transition: { duration: HERO_ENTRANCE_DURATION, ease: MOTION_EASE, delay },
});
